/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */



import { UtrvStatus } from '../constants/status';
import { UtrvAssuranceStatus } from './universalTrackerValue';


export enum DownloadType {
  Docx = 'doxc',
  /** @deprecated detailed report is merged to simple report */
  Xlsx = 'xlsx',
  Pptx = 'pptx',
  /** @deprecated detailed report is merged to simple report */
  Csv = 'csv',
  SimpleXlsx = 'simple_xlsx',
  SimpleCsv = 'simple_csv',
}

export enum VisibilityStatus {
  /** Show all available data **/
  Include = 'include',
  /** Exclude data, no utrv's returned **/
  ExcludeData = 'exclude_data',
  /**
   * Remove value, valueData, note properties only
   * Required to generated Word docs, but explicitly handle private values
   **/
  ExcludeValuesOnly = 'exclude_values',
}

export interface DownloadDisplayOptions {
  displayUserInput?: boolean;
  displayTag?: boolean;
}

export interface DownloadScopeType {
  standards: string[];
  frameworks: string[];
  custom: string[];
  sdg: string[];
}

export interface DownloadMultiScope extends DownloadDisplayOptions {
  statuses?: UtrvStatus[];
  assuranceStatus?: UtrvAssuranceStatus[];
  visibility?: VisibilityStatus;
  scope: DownloadScopeType,
  targets?: boolean;
}

interface DownloadOption {
  handler: () => Promise<void>;
  icon: string;
  type: string;
}

export interface DownloadGroup {
  id: 'word' | 'simple' | 'detailed' | 'sdg' | 'pptx';
  title: string;
  tooltip: string;
  options: DownloadOption[];
  hidden?: boolean;
}

export interface ScopeTotals { total: number; verified: number; sentToAssurer: number; assured: number };

export interface CardsTotals {
  [key: string]: ScopeTotals;
}
